import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ILeadIntegrationDetails } from "../integrationModel";
import { API_BASE_URL } from "../../../_contstants/common";
import { SuccessToast } from "../../../components/toast/Toasts";

export const getAllFacebookPages = createAsyncThunk(
  "me/accounts",
  (accessToken: any) => {
    return axiosApiInstance
      .get(`${API_BASE_URL}/me/accounts`, {
        params: {
          access_token: accessToken,
          pretty: 1,
          limit: 500,
          fields: "access_token,id,name",
        },
      })
      .then((response: any) =>
        response.data?.data
          ? response.data?.data.map((leadform: any) => leadform)
          : []
      );
  }
);

export const getLeadFormByPageID = createAsyncThunk(
  "lead/leadgen_forms",
  (formData: any) => {
    return axiosApiInstance
      .get(`${API_BASE_URL}/${formData?.pageId}/leadgen_forms`, {
        params: {
          access_token: formData?.accessToken,
          pretty: 1,
          limit: 500,
        },
      })
      .then((response: any) =>
        response.data?.data
          ? response.data?.data.map((leadform: any) => leadform)
          : []
      );
  }
);

//integration Section
export const getAllIntegrations = createAsyncThunk(
  "FacebookFormMapping/FindAll",
  () => {
    return axiosApiInstance
      .get(`${API_URL}/FacebookFormMapping/FindAll`)
      .then((response) => {
        return response.data.Data;
      });
  }
);

export const createIntegration = createAsyncThunk(
  "FacebookFormMapping/InsertAndGet",
  async (formData: any) => {
    return await axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/InsertAndGet`, formData)
      .then((response) => {
        SuccessToast(response.data.Details);
        return response;
      });
  }
);

export const updateIntegration = createAsyncThunk(
  "FacebookFormMapping/UpdateAndGet",
  async (formData: any) => {
    return await axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/UpdateAndGet`, formData)
      .then((response) => {
        SuccessToast(response.data?.Message);
        return response;
      });
  }
);

export const getIntegrationByID = createAsyncThunk(
  "FacebookFormMapping/FindByID",
  (ID: number) => {
    return axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/FindByID`, {
        ID: ID,
      })
      .then((response: any) => {
        const integration: ILeadIntegrationDetails = {
          ID: response.data.Data?.ID,
          Title: response.data.Data?.Title,
          FormID: response.data.Data?.FormID,
          PageID: response.data.Data?.PageID,
        };
        return integration;
      });
  }
);

export const deleteIntegration = createAsyncThunk(
  "FacebookFormMapping/Delete",
  (ID: number) =>
    axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/Delete`, {
        ID: ID,
      })
      .then((response) => {
        SuccessToast(response.data?.Details);
        return response;
      })
);

export const getAllStudentLeads = createAsyncThunk(
  "FacebookFormMapping/FacebookLeadsByFormID",
  (FormID: string) => {
    return axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/FacebookLeadsByFormID`, {
        FormID: FormID,
      })
      .then((response) => {
        return response.data.Data;
      });
  }
);

export const updatePageSubscription = createAsyncThunk(
  "FacebookFormMapping/PageSubscribe",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FacebookFormMapping/PageSubscribe`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Subscription:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
